DialogController = App.loadClass 'core::Angular/DialogController'

class exports.SeedCompanyDialogController extends DialogController

    constructor: (@scope, @transitions, @modalInstance, @service, @q, @http) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Add New Seed Company'
        @scope.absolute_errors = false

        @http.get 'backend/admin/new-tools/companies/get-countries'
        .then (response) =>
            @scope.countries = response.data
            console.log @scope.countries

        @scope.name = ''
        @scope.country = 'United States'

    save: (pretend = false) =>
        @scope.$emit 'save' if not pretend
        return @service.saveSeedCompany(pretend, @scope.name, @scope.country).then (response) =>
            @scope.validationErrors = null
            @closeWithAlert(response.data.status, response.data.data) if not pretend
        .catch (response) =>
            if response.status is 422
                @scope.validationErrors = response.data
            @q.reject()
